module.exports = __webpack_public_path__ + "img/winnaarsdriehoek.a99317af.png";